'use strict';

var arrayWithHoles = require('./arrayWithHoles.js');
var iterableToArray = require('./iterableToArray.js');
var nonIterableRest = require('./nonIterableRest.js');

function _toArray(arr) {
  return arrayWithHoles(arr) || iterableToArray(arr) || nonIterableRest();
}

module.exports = _toArray;
